// Adapted from: https://stackblitz.com/edit/angular-x32any?file=src%2Fapp%2Fglobals.ts
import { Injectable } from '@angular/core';
import { DeviceInfo } from '../models/device-Info';

@Injectable({
    providedIn: 'root'
})
export class GlobalVariables {
    // public static switchURL = 'https://omniswitch.netvendor.co.za/api/smartpos/';
    deviceInfo: DeviceInfo;
    userInfo: any;
    vendorSettings: any;
    printerValue: any;

}
